// Card. Soft surface for grouping content. Used for product tiles, operator list, etc.

import type { CSSProperties, ReactNode } from "react";

type Props = {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  onClick?: () => void;
  selected?: boolean;
};

export function Card({ children, style, className, onClick, selected }: Props) {
  return (
    <div
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={className}
      style={{
        border: selected ? "2px solid var(--color-primary)" : "1px solid var(--border-subtle)",
        background: selected ? "var(--surface-brand-soft)" : "var(--surface-raised)",
        borderRadius: "var(--radius-md)",
        boxShadow: "var(--shadow-sm)",
        padding: "var(--space-4)",
        cursor: onClick ? "pointer" : "default",
        transition: "border-color 120ms, box-shadow 120ms",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
